export default {"src":"/_next/static/media/wire-transfer.d96b7978.svg","height":22,"width":35,"blurWidth":0,"blurHeight":0};